// extracted by mini-css-extract-plugin
export default {"HoverDesc":"HoverDesc_HoverDesc__C3Wic","description":"HoverDesc_description__vYxVD","right":"HoverDesc_right__wUeXd"};